import { StaffUserType, JobFunctions } from './constants';

export const getColumnWidth = (staffUserType: string): Record<string, string> => {
  let columnWidth = { roleWidth: '35%', JobFunctionWidth: '20%' };
  if (staffUserType === StaffUserType.district) {
    columnWidth = { roleWidth: '45%', JobFunctionWidth: '25%' };
  }
  return columnWidth;
}

export const availableOneRosterSisCodes = <T>(mapping: unknown, defaultCodes: T[]): T[] => {
  const usedCodes = Object.values(mapping).reduce((acc: any, val: any) => acc.concat(...(val.titles || [])), []);
  const availableCodes = defaultCodes.reduce((acc, defaultCode) => {
    (defaultCode as any).used = usedCodes.includes((defaultCode as any).value);
    return acc.concat(defaultCode);
  }, []);
  return availableCodes;
};

export const changeJobFunctionMapping = (
  navkey: string,
  val: number,
  mapping: any,
  staffUserType: string,
  setMapping: any,
  setLoading: (loading: boolean) => void,
  setValidationErrorRows: (validationErrorRows: any) => void,
): void => {
  setLoading(true);
  const updatedMapping = { ...mapping };
  if (val || val === 0) {
    updatedMapping[navkey] = {
      ...updatedMapping[navkey],
      jobFunction: val,
    };
    if (
      staffUserType === StaffUserType.school &&
      (val === JobFunctions.SCHOOL_TEACHER || val === JobFunctions.SCHOOL_COUNSELOR)
    ) {
      updatedMapping[navkey] = {
        ...updatedMapping[navkey],
        ...(val === JobFunctions.SCHOOL_TEACHER ? { isTeacher: 1 } : {}),
        ...(val === JobFunctions.SCHOOL_COUNSELOR ? { isCounselor: 1 } : {}),
      };
    }
  } else {
    delete updatedMapping[navkey]?.jobFunction;
  }
  setValidationErrorRows({});
  setMapping(updatedMapping);
  setLoading(false);
};

export const changeTitlesMapping = (
  navkey: string,
  val: string[],
  mapping: any,
  setMapping: any,
  setValidationErrorRows: (validationErrorRows: any) => void,
  setLoading: (loading: boolean) => void,
  staffUserType,
): void => {
  setLoading(true);
  const updatedMapping = { ...mapping };

  const newTitleInserted = val.length > (updatedMapping[navkey]?.titles?.length || 0);
  const titleRemoved = val.length < updatedMapping[navkey]?.titles?.length;
  // for title if any entry is removed, remove the title and corresponding cleverUserType from titleUserTypeMap
  if (titleRemoved) {
    const titlesMap = {};
    const titles = val;
    for (const title of titles) {
      titlesMap[title] = true;
    }
  }

  // If school user auto populate clever user type(Staff) if one title is selected
  if (newTitleInserted && val.length === 1) {
    updatedMapping[navkey] = {
      ...updatedMapping[navkey],
      ...(staffUserType === 'district' && { jobFunction: 0 }),
    };
  }

  if (val?.length === 0) {
    delete updatedMapping[navkey];
  } else {
    updatedMapping[navkey] = {
      ...updatedMapping[navkey],
      titles: val,
    };
  }
  console.log('updatedMapping', updatedMapping);
  setValidationErrorRows({});
  setMapping(updatedMapping);
  setLoading(false);
};

export const getNavianceRolesMap = (data): any => {
  const navRolesMap = {};
  data.forEach((role) => {
    if (navRolesMap[role.name]) {
      navRolesMap[role.name] = [
        ...navRolesMap[role.name],
        {
          institutionId: role.institutionId,
          id: role.id,
        },
      ];
    } else {
      navRolesMap[role.name] = [
        {
          institutionId: role.institutionId,
          id: role.id,
        },
      ];
    }
  });
  return navRolesMap;
};

export const getRolesMap = (schoolRoles: any[], districtRoles: any[]): Record<number, string> => {
  const rolesMap = {};
  schoolRoles.forEach((role) => {
    rolesMap[role.id] = role.name;
  });
  districtRoles.forEach((role) => {
    rolesMap[role.id] = role.name;
  });
  return rolesMap;
};
